import { indexData } from '@/mocks/home';

const tagClassMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            爆料专题合集
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            按主题分类浏览最新黑料爆料，从娱乐圈塌房到网红翻车，一站吃遍全网的瓜。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const target = document.querySelector('#cards');
                if (target) {
                  const headerHeight = 64;
                  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                  window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                }
              }}
              className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-secondary-100 group-hover:bg-primary-50 transition-colors">
                <i className={`${item.icon} text-foreground-600 group-hover:text-primary-500 text-lg md:text-xl transition-colors`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  {item.tag && (
                    <span
                      className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] md:text-xs font-semibold whitespace-nowrap ${
                        tagClassMap[item.tagType] || 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-400">{item.count} 篇报道</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}